import { FC, ReactNode } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import styled from 'styled-components';

interface Props {
  heading?: string;
  children?: ReactNode;
  index: number;
  value: number | boolean;
  onCloseClick: () => void;
}

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${(props) => props.theme.spacing(1)};
  padding-bottom: ${(props) => props.theme.spacing(1)};
`;

const TabPanel: FC<Props> = ({ heading, children, index, value, onCloseClick }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <HeadingContainer>
            {heading && <Typography variant="body1">{heading}</Typography>}
            <IconButton
              onClick={onCloseClick}
              sx={{ ml: 'auto' }}
            >
              <Close />
            </IconButton>
          </HeadingContainer>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
